var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('loginComponent',{attrs:{"msgerr":_vm.msg},on:{"login":_vm.loginuser,"clearmsgerr":function($event){_vm.msg=''}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }